import React from "react";
import { AppRoutes } from "./routes/AppRoutes.js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext.js";
import { ScrollToTop } from "./utils/ScrollToTop.js";

const queryClient = new QueryClient();

const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js", {
        scope: "/",
      });
      if (registration.installing) {
        console.log("Service worker installing");
      } else if (registration.waiting) {
        console.log("Service worker installed");
      } else if (registration.active) {
        console.log("Service worker active");
      }
    } catch (error) {
      console.error(`Registration failed with ${error}`);
    }
  }
};

registerServiceWorker()

function App() {



  return (
    <>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          
          <AppRoutes />
        </QueryClientProvider>
      </AuthProvider>
    </>
  )
}


export default App;
